import { css as i } from "styled-components";
import "../Theme/themes.es.js";
import "../../palettes-Bw24w7AF.js";
import { getSpacings as t } from "../Theme/utils.es.js";
import "react";
import "../../jsx-runtime-C5mzlN2N.js";
import "../../CssBaseline-Bp4jdUgb.js";
const e = {
  sm: i`
    padding: ${t("md")};
  `,
  md: i`
    padding: ${t("md")};
  `,
  lg: i`
    padding: ${t("md")};
  `
}, h = {
  sm: i`
    height: 20px;
    width: 20px;
  `,
  md: i`
    height: 20px;
    width: 20px;
  `,
  lg: i`
    height: 24px;
    width: 24px;
  `
};
export {
  h as iconSizeStyles,
  e as sizeStyles
};
